import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetProductDetailResponseDto } from "../../dtos/get-product-detail-response-dto";
import type { GetProductDraftDetailRequestDto } from "../../dtos/get-product-draft-detail-request-dto";
import { ProductQueryKeys } from "../../generators/product-query-keys";
import { ProductService } from "../../services/product-service";

type UseGetProductDraftDetailQueryParams = {
  queryParams: GetProductDraftDetailRequestDto;
  options?: Omit<UseQueryOptions<GetProductDetailResponseDto>, "queryKey">;
};

export const useGetProductDraftDetailQuery = ({
  queryParams,
  options
}: UseGetProductDraftDetailQueryParams) => {
  return useQuery({
    queryKey: ProductQueryKeys.getProductDraftDetail({ ...queryParams })
      .queryKey,
    queryFn: async () =>
      await ProductService.getProductDraftDetail({ payload: queryParams }),
    ...options
  });
};
